import React from 'react'
import styles from '@/styles/loader.module.css'

const Loader = ({ className }: { className?: string }) => {
    return (
        <div className={styles.loader + ' ' + (className || '')} />
    )
}

export default Loader